export default __webpack_public_path__ + "static/media/checked.c4b3e136.svg";